import { render, staticRenderFns } from "./LanguageTextarea.vue?vue&type=template&id=08570f14&"
import script from "./LanguageTextarea.vue?vue&type=script&lang=js&"
export * from "./LanguageTextarea.vue?vue&type=script&lang=js&"
import style0 from "./LanguageTextarea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports